import format from 'date-fns/format';

import { toDateTime } from './date';

// import { formatDateTime } from 'lib/utils-core/dateExt'
// formatDateTime(c.cell.value, 'yyyy-MM-dd HH:mm')
export function formatDateTime(date, formatStr) {
  const dateObj = toDateTime(date);
  //console.log(dateObj)
  if (!dateObj) return '';
  return format(dateObj, formatStr)
}